/* This is a copy ContentRouterWidget but turned into functional component.
The original ContentRouterWidget logic can be found here: 
https://github.com/almamedia/almadev-cr-react-component/blob/master/src/ContentRouterWidget.js
*/
import { useState, useEffect, useCallback } from 'react';

const FIVE_MINUTES = 300000; // ms
const ID = `alma-content-router-slot-ALMA_FOOTER`;

export default function AlmaFooterWidget() {
  const [timestamp, setTimestamp] = useState<string | null>(null);
  const [widget, setWidget] = useState<{ __html: string }>({ __html: '' });

  const fetchWidget = useCallback(() => {
    fetch(`https://almacrcommoncontent.net/5577dbe2b922930e0c000022/`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Widget fetch failed with status ${response.status}`);
        }
        return response.text();
      })
      .then((markup) => {
        const newTimestamp = new Date().toString();

        setTimestamp(newTimestamp);
        setWidget({ __html: markup });

        // Cache widget
        localStorage.setItem(
          ID,
          JSON.stringify({
            timestamp: newTimestamp,
            markup,
          }),
        );
      });
  }, []);

  const checkCached = useCallback(() => {
    const cached = localStorage.getItem(ID);
    if (cached === null) {
      fetchWidget();
      return;
    }

    const { timestamp: cachedTimestamp, markup } = JSON.parse(cached);

    if (
      new Date().getTime() - new Date(cachedTimestamp).getTime() >
      FIVE_MINUTES
    ) {
      // Cached widget older than five minutes
      fetchWidget();
    } else {
      // Cached widget newer than five minutes
      setTimestamp(cachedTimestamp);
      setWidget({ __html: markup });
    }
  }, [fetchWidget]);

  // Initial mount and cache check
  useEffect(() => {
    checkCached();
  }, [checkCached]);

  // Check cache every 5 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      if (
        !timestamp ||
        new Date().getTime() - new Date(timestamp).getTime() > FIVE_MINUTES
      ) {
        // Five minutes since last checked cache
        checkCached();
      }
    }, FIVE_MINUTES);

    return () => clearInterval(interval);
  }, [timestamp, checkCached]);

  // Handle script evaluation on widget update
  useEffect(() => {
    if (widget.__html) {
      const scripts = document.querySelectorAll(`#${ID} script`);

      // eval()ing scripts from widget
      Array.from(scripts).forEach((script) => {
        try {
          window.eval((script as HTMLScriptElement).text);
        } catch (_) {
          // evaluation failed, do nothing
        }
      });
    }
  }, [widget.__html]);

  return <div id={ID} dangerouslySetInnerHTML={widget} />;
}
